/**
 * @generated SignedSource<<445a2dbbeb3ef7c427a3d78d247aafe0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TiktokGoStatus = "approved" | "pending" | "rejected";
export type ApplyTiktokGoCreatorMutationInput = {
  apply: boolean;
  clientMutationId?: string | null;
  tiktokGoUniqueId?: string | null;
};
export type SnsAssociationTiktokOAuthApplyTtgoMutation$variables = {
  input: ApplyTiktokGoCreatorMutationInput;
};
export type SnsAssociationTiktokOAuthApplyTtgoMutation$data = {
  readonly applyTiktokGoCreator: {
    readonly id?: string;
    readonly message?: string;
    readonly profile?: {
      readonly isTiktokGoCreator: boolean;
      readonly tiktokGoStatus: TiktokGoStatus;
      readonly tiktokGoUniqueId: string | null;
    };
  };
};
export type SnsAssociationTiktokOAuthApplyTtgoMutation = {
  response: SnsAssociationTiktokOAuthApplyTtgoMutation$data;
  variables: SnsAssociationTiktokOAuthApplyTtgoMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isTiktokGoCreator",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tiktokGoStatus",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "tiktokGoUniqueId",
  "storageKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "UserError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SnsAssociationTiktokOAuthApplyTtgoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "applyTiktokGoCreator",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "InfluencerInfo",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SnsAssociationTiktokOAuthApplyTtgoMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "applyTiktokGoCreator",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "InfluencerInfo",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Influencer",
            "abstractKey": null
          },
          (v6/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e11d484626d298fd79d44e8b8e310f49",
    "id": null,
    "metadata": {},
    "name": "SnsAssociationTiktokOAuthApplyTtgoMutation",
    "operationKind": "mutation",
    "text": "mutation SnsAssociationTiktokOAuthApplyTtgoMutation(\n  $input: ApplyTiktokGoCreatorMutationInput!\n) {\n  applyTiktokGoCreator(input: $input) {\n    __typename\n    ... on Influencer {\n      id\n      profile {\n        isTiktokGoCreator\n        tiktokGoStatus\n        tiktokGoUniqueId\n        id\n      }\n    }\n    ... on UserError {\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "c9adff6be015b9b3364143430580799a";

export default node;
